import { changeUiState } from './uiActions';

export function amendCart(action,productType,product){
  return (dispatch,getState)=>{
    let { quote } = getState()['ui']['tempData'];
    // console.log(quote);
    // console.log(action);
    // console.log(productType);
    // console.log(product);
    let exist = { value :  false , cartIndex : null , cartQuantity : 0 };
    quote[productType].map((cartItem,index)=>{
      exist = (cartItem.header === product.header) ? { value : true , cartIndex : index , cartQuantity : cartItem.quantity } : exist;
    });
    const { cartQuantity , value , cartIndex } = exist;
    if(action === 'add'){
      const newTotalPrice =  quote.totalPrice + product.price*1;
      if(value){
        const newQuantity = cartQuantity + 1;
        return dispatch(changeUiState([{ keys : ['tempData','quote',productType,cartIndex,'quantity'] , value : newQuantity },{ keys : ['tempData','quote','totalPrice'] , value : newTotalPrice }]));
      } else {
        const newCartItem = { header : product.header , price : product.price , quantity : 1 };
        return dispatch(changeUiState([{ keys : ['tempData','quote',productType] , action : 'updateIn' , update : { type : 'push' } , value : newCartItem },{ keys : ['tempData','quote','totalPrice'] , value : newTotalPrice }]));
      }
    } else if (action === 'minus') {
      const minusTotalPrice = quote.totalPrice - product.price*1;
      const minusQuantity = cartQuantity - 1;
      // console.log(minusQuantity);
      // console.log(minusTotalPrice);
      if(value){
        if(minusQuantity === 0){
          // console.log('Remove From Cart');
          return dispatch(changeUiState([{ keys : ['tempData','quote',productType] , action : 'updateIn' , update : { type : 'filter' , index : cartIndex } },{ keys : ['tempData','quote','totalPrice'] , value : minusTotalPrice }]));
        } else {
          // console.log('Update Cart');
          return dispatch(changeUiState([{ keys : ['tempData','quote',productType,cartIndex,'quantity'], value : minusQuantity },{ keys : ['tempData','quote','totalPrice'] , value : minusTotalPrice }]));
        }
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/quoteActions.js
 **/